import axios from '@/jslib/axios'

export const createCheque = data => {
  return axios({
    method: 'post',
    url: '/admin/cheque/create',
    data
  })
}

export const deleteCheque = data => {
  return axios({
    method: 'delete',
    url: '/admin/cheque/delete',
    data
  })
}
 
export const markDoneCheque = data => {
  return axios({
    method: 'patch',
    url: '/admin/cheque/mark/done',
    data
  })
}

export const getChequeList = params => {
  return axios({
    method: 'get',
    url: '/admin/cheque/list',
    params
  })
}

export const downloadChequeList = params => {
  return axios({
    method: 'get',
    url: '/admin/cheque/download',
    responseType: 'blob',
    params,
    timeout: 120000
  })
}